module.exports = __webpack_public_path__ + "img/agrobex.c5860340.jpg";